import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
`

export const IconWrapper = styled.div`
  font-size: 48px;
  color: var(--vo-slate);
  margin-bottom: 16px;
`

export const Message = styled.p`
  font-size: 16px;
  color: var(--vo-slate);
  margin: 0 0 16px 0;
  max-width: 400px;
`

export const ActionWrapper = styled.div``
